export const LOAD_LICENCEREPORT = 'load'
export const SAVE_LICENCEREPORT = 'save'

export const TRASH_LICENCEREPORT = 'trash'
export const UNTRASH_LICENCEREPORT = 'untrash'
export const DELETE_LICENCEREPORT = 'delete'
